import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompanyUserService } from 'src/app/settings/services/company-user.service';

@Component({
  selector: 'app-receiver-create-process-dialog-component',
  templateUrl: './receiver-create-process-dialog-component.html',
  styleUrls: ['./receiver-create-process-dialog-component.scss'],
})
export class ReceiverCreateProcessDialogComponent implements OnInit {
  @Input() loading: boolean = false;

  newReceiver: any;
  error: any;

  constructor(
    public dialogRef: MatDialogRef<ReceiverCreateProcessDialogComponent>,
    public companyUserService: CompanyUserService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (!this.data.company._id) this.dialogRef.close({ status: 'error' });
  }

  ngOnInit(): void {
    this.createReceiver();
  }

  createReceiver() {
    this.loading = true;

    this.companyUserService.createReceiver(this.data.company._id).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.newReceiver = res.data.newReceiver;
      },
      error: (error: any) => {
        this.loading = false;
        this.newReceiver = null;
        this.error = error.error;
      },
    });
  }

  onOk(): void {
    return this.newReceiver
      ? this.dialogRef.close({ status: 'confirm', newReceiver: this.newReceiver })
      : this.dialogRef.close({ status: 'error' });
  }
}
